// @flow
import React, { Component } from 'react'
import Chart from './chart'
import FilterRow from './FilterRow'
import { timeParse } from 'd3-time-format'
import { Row, Col } from 'antd'
import { TypeChooser } from 'react-stockcharts/lib/helper'

const parseDate = timeParse('%Y-%m-%d')

type State = {
  data: Object[],
  isLoading: boolean,
  symbol: string,
  period: string,
  indicators: Object[]
}


class ChartView extends Component<{}, State> {

  state: State = {
    data: [],
    isLoading: true,
    symbol: this.props.symbol,
    period: '5y',
    indicators: []
  }

  componentDidMount() {
    this.getChartData()
  }

  getChartData = async () => {

    const { symbol, period } = this.state

    try {

      const response = await fetch(`https://cloud.iexapis.com/v1/stock/${symbol}/chart/${period}?token=pk_ff59a3b39cf04827aed30a4797e5a6f0`)
      const jsonData = await response.json()
      const data = jsonData.map(x => ({...x, date: parseDate(x.date)}))
      this.setState({
        data,
        isLoading: false,
      })

    } catch(err) {

      this.setState({
        isLoading: false,
      })
    }
  }

  onChangeFilter = (objState: Object) => {

    this.setState({
      ...objState,
    }, ()=> {
      this.getChartData()
    })
  }

  render() {

    const {
      isLoading,
      symbol,
      period,
      indicators,
      data
    } = this.state

    return (
      <div>
        <FilterRow onChangeFilter={this.onChangeFilter} state={{symbol, period, indicators}} target={symbol} />
        <Row>
          <Col className='mt-5'>
            <div style={{marginTop: 10}}>
              { isLoading ?
                <div>Loading....</div> :
                data.length > 0 &&
                <TypeChooser>
                    {type => <Chart type={type} data={this.state.data} indicators={indicators}/>}
                </TypeChooser>
              }
              {
                data.length === 0 && !isLoading && <div> No data found. Please change filters.</div>
              }
            </div>
          </Col>
        </Row>
      </div>
    )
  }
}

export default ChartView



// WEBPACK FOOTER //
// ./src/components/view-chart/index.js